import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=f392b37c&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f392b37c')) {
      api.createRecord('f392b37c', component.options)
    } else {
      api.reload('f392b37c', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=f392b37c&", function () {
      api.rerender('f392b37c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QfxFMRpAI2Wg/JS/comp/FavElement.vue"
export default component.exports